import React from 'react'
import { Modal } from 'antd'
import { RowTable } from '../../../components/_utils/RowTable'

const viewWithdrawalIssueModal = (props) => {
  const { visible, onClose, record } = props


  return (
    <Modal
      title={`Raised Request`}
      visible={visible}
      onCancel={onClose}
      footer={false}
      width={'35%'}>
      <div className={'tableBox striped custom-table'}>
        <RowTable
          title={'Issue'}
          value={record.issue}
        />
        <RowTable
          title={'Status'}
          value={(
            <div>
              {record.status == 'Approved' && <label className={'label label-success-green label-sm'}>Approved</label>}
              {record.status == 'Pending' && <label className={'label label-warning  label-sm'}>Pending</label>}
              {record.status == 'Rejected' && <label className={'label label-danger  label-sm'}>Rejected</label>}
            </div>
          )} />
        <RowTable
          title={'Details'}
          value={record.note}
        />

        {record.status !== 'Pending' &&
        <RowTable
          title={record.status == 'Approved' ? 'Note' : 'Reason'}
          value={record.approvedNote || record.rejectReason} />}


        {record.contactDetails && record.contactDetails.name &&
        <div>
          <RowTable
            title={'Name'}
            value={record.contactDetails && record.contactDetails.name} />
          <RowTable
            title={'position'}
            value={record.contactDetails && record.contactDetails.position} />
          <RowTable
            title={'mobile'}
            value={(
              <div>
                {record.contactDetails && record.contactDetails.countryCode} {record.contactDetails && record.contactDetails.mobile}
              </div>
            )} />
        </div>
        }
      </div>
    </Modal>
  )
}

export default viewWithdrawalIssueModal
